import { create } from "zustand"

interface InitializationStatus {
  isInitialized: boolean
  setIsInitialized: (isInitialized: boolean, isLoggedIn: boolean) => void
  isLoggedIn: boolean
}

const useInitializationStatus = create<InitializationStatus>()((set) => ({
  isInitialized: false,
  isLoggedIn: false,
  setIsInitialized: (isInitialized: boolean, isLoggedIn: boolean) =>
    set({ isInitialized, isLoggedIn }),
}))

export { useInitializationStatus }
